export default "__VITE_ASSET__1UBX$Bi8__"